module.exports = function () {
    let isMenuOpen = false;
    let isDesktop = window.matchMedia("(min-width: 1200px)")

    const button = document.querySelector('#menu-burger'),
        menu = document.querySelector('.menu-navbar-menu-container');

    const openMenu = () => {
        if (!isMenuOpen) {
            isMenuOpen = true;
            button.classList.add('isActive');
            menu.classList.add('isActive');
        }
    }

    const closeMenu = () => {
        if (isMenuOpen) {
            isMenuOpen = false;
            button.classList.remove('isActive');
            menu.classList.remove('isActive');
        }
    }

    const toggleMenu = () => {
        if (isMenuOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    }

    const handleDesktopChange = (e) => {
        // Check if the media query is true and reset menu
        if (e.matches) {
            closeMenu();
            resetDropdowns();
        } else {
            hideAllDropdowns();
        }
    }

    // Dropdowns Inside Menu
    const menuDropdowns = $('.menu-navbar-menu-container .menu-item-has-children');

    const hideAllDropdowns = () => {
        menuDropdowns.each(function () {
            $(this).find("ul.sub-menu").slideUp();
            $(this).removeClass('isActive');
        });
    }

    const hideOpenDropdowns = () => {
        menuDropdowns.each(function () {
            if ($(this).hasClass('isActive')) {
                $(this).find("ul.sub-menu").slideUp();
                $(this).removeClass('isActive');
            }
        });
    }

    const resetDropdowns = () => {
        menuDropdowns.each(function () {
            $(this).removeClass('isActive');
            $(this).find("ul.sub-menu").slideDown(0, () => {
                $(this).find("ul.sub-menu").removeAttr('style');
            });
        })
    }

    const showDropdownAfterClick = () => {
        menuDropdowns.each(function () {
            const link = $(this).first("a");

            link.on('click', (e) => {
                e.stopPropagation();
                if (!isDesktop.matches) {
                    // allow click to sites while menu is open
                    if (!$(e.target).parents('.sub-menu').length > 0) {
                        e.preventDefault();
                    }
                    if ($(this).hasClass('isActive')) {
                        $(this).toggleClass('isActive');
                        $(this).find('ul.sub-menu').slideToggle();
                    } else {
                        hideOpenDropdowns();
                        $(this).toggleClass('isActive');
                        $(this).find('ul.sub-menu').slideToggle();
                    }
                }
            });
        });
    }

    // toggle menu on events
    button.addEventListener('click', () => {
        toggleMenu();
    });
    showDropdownAfterClick();
    handleDesktopChange(isDesktop);

    isDesktop.addEventListener("change", () => {
        handleDesktopChange(isDesktop)
    });

    const menuItems = document.querySelectorAll(".menu-item");

    menuItems.forEach(item => {
        item.addEventListener("focusin", () => {
            menuItems.forEach(item => item.classList.remove("focus"));
            item.classList.add("focus");
            
            document.addEventListener("mousemove", mouseMove);
        })

        item.addEventListener("focusout", () => {
            if ( !item.classList.contains('menu-item-has-children') ) {
                item.classList.remove("focus");
                document.removeEventListener("mousemove", mouseMove);
            }
        })
        
        const mouseMove = () => {
            item.classList.remove("focus");
        }
    })
};